'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cursorPointer = {
  cursor: 'pointer',
  color: '#20c49e'
};

var smallFont = {
  fontSize: '60%',
  color: 'grey'
};

var SupportingDataModal = function SupportingDataModal(_ref) {
  var asset = _ref.asset;
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      trigger: _react2.default.createElement(
        'div',
        { style: cursorPointer },
        _react2.default.createElement(_semanticUiReact.Icon, {
          title: 'view full story performance data (including media)',
          name: 'expand'
        }),
        _react2.default.createElement(
          'div',
          { style: smallFont },
          'view...'
        )
      )
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      _lodash2.default.get(asset, 'platform') === 'VK' ? 'VK' : _lodash2.default.capitalize(_lodash2.default.get(asset, 'platform')),
      ' Performance'
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(_body2.default, asset)
    )
  );
};

SupportingDataModal.propTypes = {
  asset: _propTypes2.default.object.isRequired
};

exports.default = SupportingDataModal;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/supporing-data-modal/index.js
 ** module id = 2567
 ** module chunks = 0
 **/